import React, {useState} from "react";
import { Modal } from 'react-bootstrap';

export default function PP() {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            <span onClick={handleShow} style={{}} className="cursor mail">
                Privacy Policy
            </span>
            <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
            <Modal.Title>Privacy Policy</Modal.Title>
            </Modal.Header>
            <Modal.Body>     
                <p><strong><strong>Earn Extra Income</strong></strong></p>   
                <ol>Make more money to do the things you love as you earn through our generous commissions and incentives. </ol>               
                <p><strong><strong>Open to Everyone</strong></strong></p>
                <ol>Anyone can become a Bitmasta agent, including individuals and business owners. So long as you own a smartphone, you can start today. </ol>
                <p><strong><strong>Refer Your Friends</strong></strong></p>
                <ol>You can refer your friends to help them add an extra source of revenue, even as you earn more money on all their transactions. </ol>
                <p><strong><strong>Start for Free</strong></strong></p>
                <ol>It costs absolutely nothing to start selling crypto with Bitmasta. Register for free to become an agent today.  </ol>
            </Modal.Body>
            </Modal>
        </>
    )
}
